/* =========================================================
   nikalab — Kreatyna × Perimenopauza LP — Shopify
   Vanilla JS, no dependencies.
   Offer widget block (dose/plan/qty/freq/ship-modal/add-to-cart)
   is ported verbatim from kreatyna-lp.js so behaviour matches
   the existing Kreatyna LP 1:1.
   ========================================================= */
(function () {
  'use strict';

  /* ---- Reveal on scroll ---- */
  (function () {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  })();

  /* ---- Symptoms checklist ("czy to brzmi znajomo?") ---- */
  (function () {
    var section = document.querySelector('[data-symptoms]');
    if (!section) return;

    var items = [].slice.call(section.querySelectorAll('[data-symptom]'));
    var dots = [].slice.call(section.querySelectorAll('[data-symptom-dot]'));
    var countEl = section.querySelector('[data-symptoms-count]');
    var signalEl = section.querySelector('[data-symptoms-signal]');
    var signals = [];
    try { signals = JSON.parse(section.getAttribute('data-signals') || '[]'); } catch (e) { signals = []; }

    function sync() {
      var count = items.filter(function (it) { return it.classList.contains('is-checked'); }).length;
      if (countEl) countEl.textContent = count;
      if (signalEl) signalEl.textContent = signals[count] || '';
    }

    items.forEach(function (item, i) {
      var btn = item.querySelector('.peri-symptom-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        item.classList.toggle('is-checked');
        if (dots[i]) dots[i].classList.toggle('is-on', item.classList.contains('is-checked'));
        sync();
      });
    });

    sync();
  })();

  /* ---- FAQ accordion (single open) ---- */
  (function () {
    var list = document.querySelector('.peri-faq-list');
    if (!list) return;
    list.addEventListener('click', function (e) {
      var q = e.target.closest('.peri-faq-q');
      if (!q) return;
      var item = q.closest('.peri-faq-item');
      var wasOpen = item.classList.contains('is-open');
      list.querySelectorAll('.peri-faq-item.is-open').forEach(function (it) { it.classList.remove('is-open'); });
      if (!wasOpen) item.classList.add('is-open');
    });
  })();

  /* ---- Sticky mobile CTA: show after hero, hide over offer ---- */
  (function () {
    var sticky = document.querySelector('[data-sticky-cta]');
    var hero = document.querySelector('.peri-hero');
    var offer = document.getElementById('zamow');
    var footer = document.querySelector('.peri-footer');
    if (!sticky || !hero) return;
    var heroOut = false, offerIn = false;
    function sync() {
      var visible = heroOut && !offerIn;
      sticky.classList.toggle('is-visible', visible);
      if (footer) footer.style.paddingBottom = visible ? sticky.offsetHeight + 'px' : '';
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { heroOut = !en.isIntersecting; sync(); });
    }, { threshold: 0 }).observe(hero);
    if (offer) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { offerIn = en.isIntersecting; sync(); });
      }, { threshold: 0 }).observe(offer);
    }
    window.addEventListener('resize', sync);
  })();

  /* ---- Shipping modal ---- */
  (function () {
    var modal = document.getElementById('ship-modal');
    if (!modal) return;
    var polCost = document.getElementById('ship-pl-cost');

    function openModal(e) {
      e.preventDefault();
      var isSub = !!e.currentTarget.closest('.oc-sub');
      if (polCost) polCost.innerHTML = isSub
        ? '<b>15 zł</b> <em>(darmowa od 150 zł)</em>'
        : '<b>15 zł</b>';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeModal() { modal.hidden = true; document.body.style.overflow = ''; }

    document.querySelectorAll('.oc-link').forEach(function (a) { a.addEventListener('click', openModal); });
    modal.querySelectorAll('[data-ship-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
  })();

  /* ================================================================
     OFFER WIDGET — ported verbatim from kreatyna-lp.js
     ================================================================ */
  (function () {
    var cfg = window.kreatyna_lp_config;
    if (!cfg) return;

    var currentDose = '3';
    var currentPlan = 'sub';
    var currentFreq = cfg.defaultFrequency || '30';
    var currentQty  = { sub: 1, one: 1 };
    var PRICES       = cfg.prices;
    var SELLING_PLANS = cfg.sellingPlans;

    function parsePlanId(key) {
      var n = parseInt(String(key).replace('selling_plan_', ''), 10);
      return isNaN(n) ? key : n;
    }

    function setText(sel, txt) {
      var el = document.querySelector(sel);
      if (el != null && txt != null) el.textContent = txt;
    }

    function parseNum(str) {
      return parseFloat(String(str).replace(/[^\d,]/g, '').replace(',', '.')) || 0;
    }

    function fmtPrice(num) {
      return num.toFixed(2).replace('.', ',');
    }

    function applyPrices() {
      var p = PRICES[currentDose];
      if (!p) return;

      var subQty = currentQty.sub;
      var oneQty = currentQty.one;

      setText('.oc-sub .oc-price b',   fmtPrice(parseNum(p.sub.price) * subQty));
      setText('.oc-sub .oc-price s',   fmtPrice(parseNum(p.sub.was)   * subQty) + ' zł');
      setText('.oc-sub .oc-perday',    p.sub.day);
      setText('.oc-sub .oc-cta-price', fmtPrice(parseNum(p.sub.price) * subQty) + ' zł');

      setText('.oc-one .oc-price b',   fmtPrice(parseNum(p.one.price) * oneQty));
      setText('.oc-one .oc-cta-price', fmtPrice(parseNum(p.one.price) * oneQty) + ' zł');

      document.querySelectorAll('[data-dose-g]').forEach(function (el) {
        el.textContent = currentDose;
      });

      var subBtn = document.querySelector('.oc-sub .oc-cta');
      if (subBtn && cfg.variants) {
        subBtn.dataset.variantId   = cfg.variants[currentDose];
        subBtn.dataset.sellingPlan = SELLING_PLANS[currentFreq];
      }
      var oneBtn = document.querySelector('.oc-one .oc-cta');
      if (oneBtn && cfg.variants) {
        oneBtn.dataset.variantId = cfg.variants[currentDose];
      }
    }

    var doseBtns = [].slice.call(document.querySelectorAll('.dose-opt'));
    doseBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        doseBtns.forEach(function (x) { x.classList.remove('sel'); x.setAttribute('aria-selected', 'false'); });
        b.classList.add('sel');
        b.setAttribute('aria-selected', 'true');
        currentDose = b.dataset.dose;
        currentQty  = { sub: 1, one: 1 };
        document.querySelectorAll('.qval').forEach(function (el) { el.textContent = '1'; });
        applyPrices();
      });
    });

    var cards = [].slice.call(document.querySelectorAll('.oc'));
    cards.forEach(function (c) {
      c.addEventListener('click', function (e) {
        if (e.target.closest('.qty') || e.target.closest('.oc-cta') ||
            e.target.closest('.freq') || e.target.closest('.freq-pop') ||
            e.target.closest('.oc-link')) return;
        cards.forEach(function (x) { x.classList.remove('sel'); });
        c.classList.add('sel');
        currentPlan = c.dataset.plan2 || 'sub';
      });
    });

    document.querySelectorAll('[data-qty]').forEach(function (q) {
      var val     = q.querySelector('.qval');
      var planKey = q.closest('.oc-one') ? 'one' : 'sub';
      q.querySelector('.qmin').addEventListener('click', function (ev) {
        ev.stopPropagation();
        currentQty[planKey] = Math.max(1, currentQty[planKey] - 1);
        if (val) val.textContent = currentQty[planKey];
        applyPrices();
      });
      q.querySelector('.qpls').addEventListener('click', function (ev) {
        ev.stopPropagation();
        currentQty[planKey] = Math.min(9, currentQty[planKey] + 1);
        if (val) val.textContent = currentQty[planKey];
        applyPrices();
      });
    });

    var freqBtn = document.querySelector('.js-freq-btn');
    var freqPop = document.querySelector('.freq-pop');
    if (freqBtn && freqPop) {
      freqBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = freqPop.hidden;
        freqPop.hidden = !isOpen;
        freqBtn.classList.toggle('is-open', isOpen);
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.freq-wrap')) {
          freqPop.hidden = true;
          freqBtn.classList.remove('is-open');
        }
      });
      freqPop.querySelectorAll('.freq-opt').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.stopPropagation();
          currentFreq = opt.dataset.freq;
          freqPop.querySelectorAll('.freq-opt').forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');

          var svg = freqBtn.querySelector('svg');
          freqBtn.textContent = 'Dostawa co ' + currentFreq + ' dni';
          if (svg) freqBtn.appendChild(svg);
          freqBtn.classList.remove('is-open');
          freqPop.hidden = true;

          var subBtn = document.querySelector('.oc-sub .oc-cta');
          if (subBtn) subBtn.dataset.sellingPlan = SELLING_PLANS[currentFreq];
        });
      });
    }

    applyPrices();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.oc-cta');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var variantId = Number(btn.dataset.variantId);
      if (!variantId) {
        console.error('[nikalab] Missing variantId on .oc-cta');
        return;
      }

      var isSub       = !!btn.closest('.oc-sub');
      var planKey     = isSub ? 'sub' : 'one';
      var qty         = currentQty[planKey] || 1;
      var sellingPlan = isSub ? parsePlanId(SELLING_PLANS[currentFreq]) : undefined;

      var originalHTML = btn.innerHTML;
      btn.disabled      = true;
      var labelEl       = btn.querySelector('.btn-label');
      if (labelEl) labelEl.textContent = 'Dodawanie...';
      else          btn.textContent    = 'Dodawanie...';

      var item = { id: variantId, quantity: qty };
      if (sellingPlan) item.selling_plan = sellingPlan;

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items: [item] })
      })
        .then(function (res) {
          if (res.ok) {
            btn.disabled  = false;
            btn.innerHTML = originalHTML;
            document.dispatchEvent(new CustomEvent('rc:cart:open', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
          } else {
            return res.json().then(function (data) {
              throw new Error(data.description || 'Błąd dodawania do koszyka');
            });
          }
        })
        .catch(function (err) {
          console.error('[nikalab] Cart error:', err);
          btn.disabled  = false;
          btn.innerHTML = originalHTML;
          alert('Wystąpił błąd. Spróbuj ponownie.');
        });
    });

  })();

})();
